/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Writing_Mode_TitleInputs */

const en_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Writing Mode (Vertical/Horizontal)`)
};

const fr_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer le Mode d'Ecriture (Vertical/Horizontal)`)
};

const de_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibmodus umschalten (Vertikal/Horizontal)`)
};

const it_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la modalità di scrittura (verticale/orizzontale)`)
};

const ru_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключение режима письма (вертикальный/горизонтальный)`)
};

const es_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar modo de escritura (vertical/horizontal)`)
};

const zh_cn2_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换书写模式（垂直/水平）`)
};

const ja_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き込みモードを切り替える（縦書き/横書き）`)
};

const hi_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लेखन मोड बदलें (ऊर्ध्वाधर/क्षैतिज)`)
};

const pt_pt2_writing_mode_title = /** @type {(inputs: Writing_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar modo de escrita (vertical/horizontal)`)
};

/**
* | output |
* | --- |
* | "Toggle Writing Mode (Vertical/Horizontal)" |
*
* @param {Writing_Mode_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const writing_mode_title = /** @type {((inputs?: Writing_Mode_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Writing_Mode_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_writing_mode_title(inputs)
	if (locale === "de") return de_writing_mode_title(inputs)
	if (locale === "it") return it_writing_mode_title(inputs)
	if (locale === "ru") return ru_writing_mode_title(inputs)
	if (locale === "es") return es_writing_mode_title(inputs)
	if (locale === "zh-CN") return zh_cn2_writing_mode_title(inputs)
	if (locale === "ja") return ja_writing_mode_title(inputs)
	if (locale === "hi") return hi_writing_mode_title(inputs)
	if (locale === "pt-PT") return pt_pt2_writing_mode_title(inputs)
	return en_writing_mode_title(inputs)
});